module.exports = __webpack_public_path__ + "static/blue-square-481d626372613bee1b01e7b04aafcb3e.webp";